import React from "react";
import { useSelector } from "react-redux";

const SelectVAT = ({ user, values, divisions, selectedTax }) => {
  const orgCountry = Object.entries(divisions).find(([k, value]) => value === values.organisation_name)?.[0];
  const isFreelance = user?.contract === "FREELANCE";
  const isDifferentCountry = user?.company_country !== orgCountry;
  const vatHoverText = isFreelance && isDifferentCountry ? `${values.organisation_name} is a ${orgCountry} company so no VAT applicable` : null;

  return (
    <input
      disabled
      className="border border-[#E5EAEF] rounded-[10px] w-full h-[40px] px-2 mt-2 text-[1rem] focus:outline-none focus:ring focus:ring-[#80bdff] bg-gray-100 text-gray-500"
      value={selectedTax}
      title={vatHoverText}
    />
  );
};
export default SelectVAT;
